export const achieverGroups = [
  {
    id: "bsc-achievers",
    title: "B.Sc Agriculture Achievers",
    subtitle: "Undergraduate Research Excellence",
    color: { bg: "rgba(14,124,75,.25)", border: "rgba(110,231,183,.25)", tag: "#6ee7b7", tagBg: "rgba(110,231,183,.12)" },
    items: [
      { name: "K. Rakesh",      place: "Agronomy Research Fellow", initials: "KR" },
      { name: "S. Anusha",      place: "Sustainable Farming Project", initials: "SA" },
      { name: "M. Rahul",       place: "Crop Science Specialist", initials: "MR" },
      { name: "P. Kavitha",     place: "Agri-Business Intern", initials: "PK" },
      { name: "V. Sanjay",      place: "Soil Health Expert", initials: "VS" },
    ],
  },
  {
    id: "msc-achievers",
    title: "M.Sc Research Scholars",
    subtitle: "Advanced Postgraduate Achievements",
    color: { bg: "rgba(21,128,61,.25)", border: "rgba(187,247,208,.25)", tag: "#15803d", tagBg: "rgba(187,247,208,.12)" },
    items: [
      { name: "Dr. Vineeth",    place: "M.Sc Genetic Research", initials: "DV" },
      { name: "A. Srikanth",    place: "Modern Biotechnology M.Sc", initials: "AS" },
      { name: "B. Meena",       place: "National Science Scholar", initials: "BM" },
      { name: "D. Satish",      place: "Sustainable Agriculture Award", initials: "DS" },
    ],
  },
  {
    id: "alumni",
    title: "Successful Alumni",
    subtitle: "Career Excellence in Sciences",
    color: { bg: "rgba(255,255,255,.15)", border: "rgba(255,255,255,.25)", tag: "#ffffff", tagBg: "rgba(255,255,255,.1)" },
    items: [
      { name: "J. Naveen",      place: "Agricultural Officer", initials: "JN" },
      { name: "E. Sindhuja",    place: "Environmental Scientist", initials: "ES" },
    ],
  },
];
